// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"9c2380ee","796":"f3dcb106"}[chunkId] + ".chunk.js";
};